// src/catalog/launch/CatalogLaunchAboutModal.jsx

import BaseModalApp from "../../components/modals/app-modals/BaseModalApp";
import AVIcon from "../../components/icons/AllVoicedIcons";
import CatalogEntryInformationPanels from "../components/detail/CatalogEntryInformationPanels";
import CatalogEntryStatusBadges from "../components/detail/CatalogEntryStatusBadges";
import {
  buildCatalogEntryHeroMetaItems,
  getCatalogEntryDetailProfile
} from "../components/detail/catalogDetailProfiles";
import {
  getPreferredLaunchConfigurationIdForEntry,
  getSelfDirectedLaunchConfigurations,
  resolveLaunchConfigurationSelectionFromList
} from "./catalogLaunchConfigurations";

function CatalogLaunchAboutModal({
  entry,
  selectedLaunchConfigurationId = null,
  isOpen,
  onRequestClose
}) {
  if (!entry) {
    return null;
  }

  const selfDirectedLaunchConfigurations =
    getSelfDirectedLaunchConfigurations(entry, {
      respectAudience: false
    });
  const explicitlySelectedLaunchConfiguration =
    entry?.metadata?.ux?.launchConfigurations?.find(
      (configuration) =>
        configuration?.id === selectedLaunchConfigurationId
    ) || null;
  const {
    selectedConfiguration: defaultLaunchConfiguration
  } = resolveLaunchConfigurationSelectionFromList(
    selfDirectedLaunchConfigurations,
    null,
    {
      preferredLaunchConfigurationId:
        getPreferredLaunchConfigurationIdForEntry(entry)
    }
  );
  const currentLaunchConfiguration =
    explicitlySelectedLaunchConfiguration ||
    defaultLaunchConfiguration;
  const detailProfile = getCatalogEntryDetailProfile(entry);
  const heroMetaItems = buildCatalogEntryHeroMetaItems(
    entry,
    detailProfile
  );

  return (
    <BaseModalApp
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="About this resource"
      className="ReactModal__Content modal--app modal--1000px catalog-launch-shell__about-modal"
      overlayClassName="ReactModal__Overlay modal-overlay--app catalog-launch-shell__about-overlay"
    >
      <div className="catalog-launch-shell__about-header">
        <div>
          <p className="catalog-launch-shell__about-eyebrow">
            Resource information
          </p>
          <h2>About this resource</h2>
        </div>

        <button
          type="button"
          className="catalog-launch-shell__about-close"
          onClick={onRequestClose}
          aria-label="Close about this resource"
        >
          <AVIcon icon="close" size={18} aria-hidden="true" />
        </button>
      </div>

      <div className="catalog-launch-shell__about-content">
        <CatalogEntryStatusBadges
          items={heroMetaItems}
          className="catalog-detail__meta catalog-launch-shell__about-meta"
        />
        <CatalogEntryInformationPanels
          entry={entry}
          selectedLaunchConfiguration={currentLaunchConfiguration}
          className="catalog-detail__info-grid catalog-detail__info-grid--stacked"
        />
      </div>
    </BaseModalApp>
  );
}

export default CatalogLaunchAboutModal;
